import * as yup from "yup";
import { IModel1 } from "./NonPerformingVendor";
import { IClientContactPerson } from "../../models/ClientContactPerson";
import { useEffect, useRef, useState } from "react";
import { IClientCompanyDropdown, IDesignationMastDropdown } from "../../models/IDropdown";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Fetch } from "../../shared/Fetch";
import { EmptyNonPerformingVendor } from "./EmptyNonPerformingVendor";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Messages } from "primereact/messages";
import { JVInputCheck } from "../../shared/JVInputCheck";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInputMask } from "../../shared/JVInputMask";
import { Button } from "primereact/button";
const schema = yup.object({
    contact_Person_EmailID: yup.string().required("EmailID is required*").email(),
    vendor_Company: yup.object().shape({
        vendor_Company_ID: yup.number().min(1, "Client Company Name is required*").required("Client Company Name is required*"),
        vendor_Company_Name: yup.string().required(),
        website_URL: yup.string()
    }).typeError("Client Company Name is required"),
    contact_Person_Name: yup.string().required("Name is required*").min(3),
    designation: yup.number().min(1, "Designation is required*").required("Designation is required*"),
    phone_No: yup.string().required("Phone No is required*"),
    ext: yup.string().nullable(),
    cell_No: yup.string().nullable(),
    major_Technology: yup.string().nullable()
});

const emailSchema = yup.object().shape({
    email: yup.string().required().email()
});

interface IVCompanyInfo {
    vendor_Company_ID?: number,
    noofReq?: number,
    noOfServe?: number,
    noOfResume?: number,
    noOfECI?: number,
    noOfPO?: number,
    noOfPOFiz?: number,
    noOfPOEnded?: number,
    noOfPOJoined?: number
}

interface Iprops {
    setModal: (modal: IModel1) => void,
    singleData: IClientContactPerson,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    // openNewForm: () => void
}

export const Form = (props: Iprops) => {
    const message = useRef<any>(null);
    const [designations, setDesignations] = useState<Array<IDesignationMastDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [vCompanyInfo, setVCompanyInfo] = useState<IVCompanyInfo>();

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IClientContactPerson>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const loadVCompanyInfo = async (vendor_company_id: number) => {
        const responseI = await Fetch(`Vendor_Company_Mast/statusCount`, "GET", null, `vendor_company_id=${vendor_company_id}`, null);
        if (responseI) {
            const data: IVCompanyInfo = await responseI.json();
            setVCompanyInfo(data);
        }
    }
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "vendor_Company") {
                if (value.vendor_Company?.vendor_Company_ID) loadVCompanyInfo(value.vendor_Company.vendor_Company_ID);
                else setVCompanyInfo(undefined);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const checkEmail = async () => {
        const valid = await emailSchema.isValid({
            email: control._formValues.contact_Person_EmailID,
        });
        if (valid) {
            const response = await Fetch("Sub_Vendor_Contact_Person_Mast/searchEmail", "GET", null, `filter=${control._formValues.contact_Person_EmailID}`, props.toast);
            response && message.current.show({ severity: 'success', content: "Email Available." });
        } else {
            message.current.show({ severity: 'error', content: "Please Enter a Valid Email" });
        }
    }

    const loadDesignations = async () => {
        const response = await Fetch("Dropdown/designation", "GET", null, null, null);
        if (response) {
            const data: Array<IDesignationMastDropdown> = await response.json();
            setDesignations(data);
        }
    }
    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }

    useEffect(() => {
        loadClientCompanies(null);
        loadDesignations();
    }, []);

    const completeMethod = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const saveToDB = async (body: IClientContactPerson) => {
        const method = props.singleData.contact_Person_ID ? "PUT" : "POST";
        const message = props.singleData.contact_Person_ID ? "Updated Successfully" : "Added Successfully";

        body.vendor_Company_ID = body.vendor_Company?.vendor_Company_ID;
        delete body.vendor_Company;

        const response = await Fetch("Sub_Vendor_Contact_Person_Mast", method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyNonPerformingVendor);
        setVCompanyInfo(undefined);
    }

    function onSubmit(data: IClientContactPerson) {
        // if (data.vendor_Company?.website_URL === "") {
        const e_domain = data.contact_Person_EmailID?.split("@")[1];
        if (!(e_domain?.includes("gmail") || e_domain?.includes("outlook")
            || e_domain?.includes("protonmail") || e_domain?.includes("aol")
            || e_domain?.includes("yahoo") || e_domain?.includes("hotmail")
            || e_domain?.includes("rediff"))) {
            saveToDB(data);
        }
        else props.toast.current.show({ severity: 'error', detail: "Contact Person Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc.", life: 3000 });
        // } else {
        //     const e_domain = data.contact_Person_EmailID?.split("@")[1];
        //     let c_domain = "";
        //     const temp_arr = data.vendor_Company?.website_URL?.split("/");
        //     if (data.vendor_Company?.website_URL?.includes("http")) {
        //         c_domain = temp_arr ? temp_arr[2] : "";
        //     } else {
        //         c_domain = temp_arr ? temp_arr[0] : "";
        //     }
        //     if (c_domain.includes("www") && temp_arr) {
        //         c_domain = c_domain.substring(4);
        //     }

        //     if (e_domain === c_domain) {
        //         saveToDB(data);
        //     }
        //     else props.toast.current.show({ severity: 'error', detail: `Contact Person Email must be of the Company. \n As - "username@${c_domain}"`, life: 5000 });
        //     // console.log(data.contact_Person_EmailID, "\n",
        //     //     e_domain, "\n",
        //     //     data.vendor_Company?.website_URL,
        //     //     "\n", c_domain);
        // }
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Non Performing Vendor" modal className="p-fluid" onHide={onHide}>
            {vCompanyInfo && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={[vCompanyInfo]}
            >
                <Column field="noofReq" header="Req#" />
                <Column field="noOfServe" header="Serv#" />
                <Column field="noOfResume" header="Sub#" />
                <Column field="noOfECI" header="ECI#" />
                <Column field="noOfPO" header="PO#" />
                <Column field="noOfPOFiz" header="POF#" />
                <Column field="noOfPOEnded" header="POE#" />
                <Column field="noOfPOJoined" header="POJ#" />
            </DataTable>}
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <div className="field col-12 md:col-12">
                    <Messages ref={message} />
                </div>
                <JVInputCheck required func={checkEmail} label="Email ID" control={control} name="contact_Person_EmailID" error={errors.contact_Person_EmailID?.message} />

                <JVDropdownInput required completeMethod={completeMethod} label="Client Company Name" control={control} name="vendor_Company" error={errors.vendor_Company?.message} options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client Company" />

                <JVInput required label="Name" control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                <JVDropdown required label="Designation" control={control} name="designation" error={errors.designation?.message} options={designations} optionLabel="designation_Name" optionValue="designationId" placeholder="Select Designation" />
                <JVInputMask mask="(999) 999-9999" required label="Phone No" control={control} name="phone_No" error={errors.phone_No?.message} />
                <JVInput label="Ext." control={control} name="ext" error={errors.ext?.message} />
                <JVInput label="Cell No" control={control} name="cell_No" error={errors.cell_No?.message} />
                <JVInput label="Major Technology" control={control} name="major_Technology" error={errors.major_Technology?.message} />

                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}